"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WasmQuerier = void 0;
const terra_js_1 = require("@terra-money/terra.js");
class WasmQuerier {
    constructor(lcd, chainId) {
        this.lcd = lcd;
        this.chainId = chainId;
    }
    getTax() {
        return this.lcd.config['tax'] || 0;
    }
    estimateFee(sender, messages, memo, feeDenoms) {
        return __awaiter(this, void 0, void 0, function* () {
            const coins = new terra_js_1.Coins(this.lcd.config.gasPrices);
            const txOptions = {
                msgs: messages.map(e => e.msg),
                memo: memo,
                feeDenoms: feeDenoms !== null && feeDenoms !== void 0 ? feeDenoms : coins.denoms()
            };
            const accountInfo = yield this.lcd.auth.accountInfo(sender);
            const signer = { sequenceNumber: accountInfo.getSequenceNumber() };
            txOptions.fee = yield this.lcd.tx.estimateFee([signer], txOptions);
            return txOptions;
        });
    }
}
exports.WasmQuerier = WasmQuerier;
